export default __webpack_public_path__ + "static/media/img1.a8f9df92.png";